<template>

<DataTable :value="data" responsiveLayout="scroll" stripedRows class="p-datatable-sm">

<template v-for="item in columns">
<Column v-if="item.type=='text'" :field="item.field" :header="item.header" :class="{'hide_on_mobile_table_cell':item.hide_on_mobile}"></Column>

<Column  v-if="item.type=='date'" :header="item.header" :class="{'hide_on_mobile_table_cell':item.hide_on_mobile}">
<template #body="slotProps">
<p>{{ $filters.momentFormat( slotProps.data[item.field]," Do MM YYYY hh:mm")}}</p>
</template>
</Column>


<Column  v-if="item.type=='boolean'" :header="item.header" :class="{'hide_on_mobile_table_cell':item.hide_on_mobile}">
<template #body="slotProps">
<p v-html="$filters.booleanView( slotProps.data[item.field])"></p>
</template>
</Column>



<Column  v-if="item.type=='relation'" :header="item.header" :class="{'hide_on_mobile_table_cell':item.hide_on_mobile}">
<template #body="slotProps">
<p>{{ slotProps.data[item.field][item.relation_field]}}</p>
</template>
</Column>



</template>





<Column headerStyle="width: 8rem; text-align: center" bodyStyle="text-align: center; overflow: visible" class="hide_on_mobile_table_cell">
<template #body="slotProps">
<div>	
<Button type="button" icon="pi pi-eye" class=" p-button-primary p-button-outlined  p-button-sm mr-2" @click="gotoPage(routename,{attribute_id:slotProps.data.id})"></Button>
<Button type="button" icon="pi pi-trash" class=" p-button-danger p-button-outlined  p-button-sm" @click="deleteItem(deleteobjectname,slotProps.data.id)"></Button>
</div>
</template>
</Column>



<Column headerStyle="width: 4rem; text-align: center" bodyStyle="text-align: center; overflow: visible" class="show_on_mobile_table_cell">
<template #body="slotProps">
 <Button type="button"  icon="pi pi-ellipsis-h" @click="toggle" aria-haspopup="true" :aria-controls="'overlay_menu'+slotProps.data.id" class="p-button-primary p-button-text p-button-sm mt-1"   />
<Menu :id="'overlay_menu'+slotProps.data.id" ref="menu" :model="items" :popup="true">
 <template #item="{item}">  
<a class="p-menuitem-link" role="menuitem" @click="item.command(item.argument,{id:slotProps.data.id})">
<span :class="'p-menuitem-icon '+item.icon"></span>
<span class="p-menuitem-text">{{item.label}}</span>
<span class="p-ink"></span></a>
</template>
</Menu>
</template>
</Column>



</DataTable>



</template>

<script>
export default {
  props:["data","columns","routename","deleteobjectname"],
  name: 'ContentTableForAttributes',

  data () {
    return {
    	items: [
    		{
                label: 'Görüntüle',
                icon: 'pi pi-eye',
                argument:this.routename,
                command: (argument,id) => {
                	console.log(argument)
                	console.log(id)
	                   this.gotoPage(argument,id)
	                }
            },
            {
                label: 'Sil',
                icon: 'pi pi-trash',
                argument:this.deleteobjectname,
                command: (argument,id) => {
	                   this.deleteItem(argument,id)
	                }
            },

    	]
    }
  },
  methods:{
  	toggle(event) {
        this.$refs.menu.toggle(event);
    },
  },
  computed:{
  	deletedstate()
  	{
  		return this.$store.state.ui.deletedstate
  	}
  },
  watch:{
  	deletedstate(newVal,oldVal)
  	{
  		if(newVal)
  		{
  			this.$emit("dataDeleted")
  		}
  	}
  }
};
</script>

<style lang="css" scoped>
</style>